<template>
  <v-snackbar
    v-model="showSnackbar"
    :color="$store.state.snackbar.color"
    :timeout="$store.state.snackbar.timeout || 6000"
    top
  >
    {{ $store.state.snackbar.text }}
    <v-btn
      text
      @click.native="showSnackbar = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'AppSnackbar',
  computed: {
    showSnackbar: {
      get() {
        return this.$store.state.showSnackbar
      },
      set(value) {
        this.$store.commit('set_showSnackbar', value)
      }
    }
  }
}
</script>
